<script setup>
const props = defineProps({
  message: {
    type: String,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value) {
      return ["primary", "secondary", "info", "warning", "danger", "success"].includes(value)
    }
  },
  icon: {
    type: String
  }
})
</script>

<template>
  <div
      class="flex rounded-md p-4"
      :class="[ 
        { 'bg-brand-primary/10': type === 'primary' },
        { 'bg-blue-500/10 border border-blue-500 text-blue-500': type === 'info' },
        { 'bg-yellow-500/10 border border-yellow-500 text-yellow-500': type === 'warning' },
        { 'bg-red-500/10 border border-red-500 text-red-500': type === 'danger' },
        { 'bg-green-500/10 border border-green-500 text-green-500': type === 'success' },
        // Add a default or handle 'secondary' if needed
        { 'bg-gray-500/10 border border-gray-500 text-gray-500': type === 'secondary' }
      ]"
  >
  <p class="flex-grow">{{ message }}</p>
  </div>
</template>